import styled from 'styled-components'
import {
  calculateResponsiveSize,
  calculateMobileResponsiveSize,
  mediaMax,
} from 'styles/media-queries'

import HeaderLogo from 'icons/logo.svg'

import InstagramLogo from 'icons/instagram.svg'
import InLogo from 'icons/in.svg'
import XLogo from 'icons/x.svg'
import FbLogo from 'icons/fb.svg'
import YoutubeLogo from 'icons/youtube.svg'

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: ${calculateResponsiveSize(40)} ${calculateResponsiveSize(40)}
    ${calculateResponsiveSize(30)} ${calculateResponsiveSize(40)};
  color: var(--light);
  background: var(--black);

  &.light-footer {
    background: var(--light);
  }
  ${mediaMax('mobile')} {
    padding: ${calculateMobileResponsiveSize(40)}
      ${calculateMobileResponsiveSize(20)} ${calculateMobileResponsiveSize(25)}
      ${calculateMobileResponsiveSize(20)};
  }
`

export const Content = styled.div`
  display: flex;
  ${mediaMax('mobile')} {
    flex-direction: column;
    align-items: center;
    gap: ${calculateMobileResponsiveSize(25)};
  }
`
export const Left = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${calculateResponsiveSize(60)};
  ${mediaMax('mobile')} {
    align-items: center;
    gap: ${calculateMobileResponsiveSize(25)};
  }
`
export const Logo = styled.div`
  width: ${calculateResponsiveSize(135)};
  height: ${calculateResponsiveSize(40)};
  -webkit-mask: url(${HeaderLogo}) no-repeat;
  -webkit-mask-size: contain;
  background: var(--light);
  display: flex;
  margin-right: ${calculateResponsiveSize(40)};
  transition: 0.5s;

  .light-footer & {
    background: var(--blue);
  }

  ${mediaMax('mobile')} {
    width: ${calculateMobileResponsiveSize(135)};
    height: ${calculateMobileResponsiveSize(40)};
    margin-right: ${calculateMobileResponsiveSize(0)};
  }
`
export const Social = styled.div`
  display: flex;
  align-items: center;
  gap: ${calculateResponsiveSize(18)};
  a {
    display: flex;
  }
  ${mediaMax('mobile')} {
    gap: ${calculateMobileResponsiveSize(18)};
    &.header {
      display: none;
    }
  }
`

export const SocialIcon = styled.a`
  width: ${calculateResponsiveSize(14)};
  height: ${calculateResponsiveSize(14)};
  -webkit-mask: url(${InstagramLogo}) no-repeat;
  -webkit-mask-size: contain;
  background: #ededed80;
  display: flex;
  transition: 0.5s;
  &.fb {
    -webkit-mask: url(${FbLogo}) no-repeat;
    -webkit-mask-size: contain;
  }
  &.x {
    -webkit-mask: url(${XLogo}) no-repeat;
    -webkit-mask-size: contain;
  }
  &.youtube {
    -webkit-mask: url(${YoutubeLogo}) no-repeat;
    -webkit-mask-size: contain;
    width: ${calculateResponsiveSize(20)};
    height: ${calculateResponsiveSize(15)};
  }
  &.in {
    -webkit-mask: url(${InLogo}) no-repeat;
    -webkit-mask-size: contain;
  }
  .light-footer & {
    background: var(--blue);
  }
  ${mediaMax('mobile')} {
    background: #ededed;
    width: ${calculateMobileResponsiveSize(12)};
    height: ${calculateMobileResponsiveSize(12)};

    &.youtube {
      width: ${calculateMobileResponsiveSize(20)};
      height: ${calculateMobileResponsiveSize(15)};
    }
  }
`

export const Right = styled.div`
  display: flex;
  margin-left: auto;
  padding: 0 ${calculateResponsiveSize(60)} 0 0;
  ${mediaMax('mobile')} {
    flex-direction: column;
    gap: ${calculateMobileResponsiveSize(20)};
    margin: 0;
    padding: 0;
  }
`

export const Title = styled.div`
  margin-bottom: ${calculateResponsiveSize(7)};
  font-family: 'Basis Grotesque';
  font-size: ${calculateResponsiveSize(12)};
  font-weight: 700;
  line-height: ${calculateResponsiveSize(19.2)};
  letter-spacing: 0.1em;
  text-align: left;
  text-transform: uppercase;

  .light-footer & {
    color: var(--blue);
  }
  ${mediaMax('mobile')} {
    margin-bottom: ${calculateMobileResponsiveSize(10)};
    font-size: ${calculateMobileResponsiveSize(10)};
    line-height: ${calculateMobileResponsiveSize(16)};
    letter-spacing: ${calculateMobileResponsiveSize(2)};
    text-align: center;
  }
`

export const TitleSocial = styled.div`
  font-family: 'Basis Grotesque Pro';
  letter-spacing: ${calculateResponsiveSize(2)};
  text-underline-position: from-font;
  text-decoration-skip-ink: none;

  font-family: 'Basis Grotesque';
  font-size: ${calculateResponsiveSize(10)};
  font-weight: 700;
  line-height: ${calculateResponsiveSize(16)};
  text-align: left;
  text-transform: uppercase;

  .light-footer & {
    color: var(--blue);
  }
  ${mediaMax('mobile')} {
    font-size: ${calculateMobileResponsiveSize(10)};
    line-height: ${calculateMobileResponsiveSize(16)};
    letter-spacing: ${calculateMobileResponsiveSize(2)};
    text-align: center;
  }
`

export const Contact = styled.div`
  width: ${calculateResponsiveSize(214)};
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  text-align: left;
  font-family: 'Canela';
  font-size: ${calculateResponsiveSize(18)};
  font-weight: 300;
  line-height: ${calculateResponsiveSize(28.8)};
  text-align: left;
  a,
  a:hover {
    display: flex;
    color: var(--light);
  }

  .light-footer & {
    color: var(--black);
    a {
      color: var(--black);
    }
  }
  ${mediaMax('mobile')} {
    width: 100%;
    font-size: ${calculateMobileResponsiveSize(16)};
    font-weight: 250;
    line-height: ${calculateMobileResponsiveSize(25.6)};
    text-align: center;
    gap: ${calculateMobileResponsiveSize(20)};
    a {
      justify-content: center;
    }
  }
`

export const Bottom = styled.div`
  display: flex;
  align-items: center;
  margin-top: ${calculateResponsiveSize(48)};
  ${mediaMax('mobile')} {
    flex-direction: column;
    align-items: center;
    gap: ${calculateMobileResponsiveSize(20)};
    margin-top: ${calculateMobileResponsiveSize(20)};
    padding-top: ${calculateMobileResponsiveSize(30)};
    border-top: 1px solid var(--mid);
  }
`
export const BText = styled.div`
  ${mediaMax('mobile')} {
    order: 2;
    display: flex;
    flex-direction: column;
    gap: ${calculateMobileResponsiveSize(10)};
  }
`

export const LocationSection = styled.div`
  display: flex;
  flex-direction: column;
  text-align: left;
  font-family: 'Canela';
  font-size: ${calculateResponsiveSize(18)};
  font-weight: 300;
  line-height: ${calculateResponsiveSize(28.8)};
  text-align: left;
  margin-right: ${calculateResponsiveSize(30)};

  .light-footer & {
    color: var(--black);
    a {
      color: var(--black);
    }
  }
  ${mediaMax('mobile')} {
    width: 100%;
    font-size: ${calculateMobileResponsiveSize(16)};
    font-weight: 250;
    line-height: ${calculateMobileResponsiveSize(25.6)};
    text-align: center;
  }
`

export const Copyright = styled.div`
  color: #ededed80;
  text-transform: uppercase;
  font-family: 'Basis Grotesque Pro';
  font-size: ${calculateResponsiveSize(10)};
  font-weight: 400;
  line-height: ${calculateResponsiveSize(16)};
  letter-spacing: ${calculateResponsiveSize(2)};
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  .light-footer & {
    color: var(--mid);
  }
  ${mediaMax('mobile')} {
    font-family: 'Basis Grotesque Pro';
    font-size: ${calculateMobileResponsiveSize(10)};
    font-weight: 400;
    line-height: ${calculateMobileResponsiveSize(16)};
    letter-spacing: ${calculateMobileResponsiveSize(2)};
    color: var(--light);
    .light-footer & {
      color: var(--blue);
      a {
        color: var(--blue);
      }
    }
  }
`

export const Creative = styled.div`
  color: #ededed80;
  text-transform: uppercase;
  font-family: 'Basis Grotesque Pro';
  font-size: ${calculateResponsiveSize(10)};
  font-weight: 400;
  line-height: ${calculateResponsiveSize(16)};
  letter-spacing: ${calculateResponsiveSize(2)};
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  .light-footer & {
    color: var(--mid);
  }
  ${mediaMax('mobile')} {
    font-family: 'Basis Grotesque Pro';
    font-size: ${calculateMobileResponsiveSize(10)};
    font-weight: 400;
    line-height: ${calculateMobileResponsiveSize(16)};
    letter-spacing: ${calculateMobileResponsiveSize(2)};
    color: var(--light);
    text-align: center;
    .light-footer & {
      color: var(--blue);
      a {
        color: var(--blue);
      }
    }
  }
`

export const Links = styled.ul`
  display: flex;
  align-items: center;
  margin-left: auto;
  text-transform: uppercase;
  gap: ${calculateResponsiveSize(24.5)};
  font-family: 'Basis Grotesque Pro';
  font-size: ${calculateResponsiveSize(10)};
  font-weight: 400;
  line-height: ${calculateResponsiveSize(16)};
  letter-spacing: ${calculateResponsiveSize(2)};

  a,
  a:hover,
  a:active,
  a:visited {
    color: #ededed80;
  }
  &.menu {
    a,
    a:hover,
    a:active,
    a:visited {
      color: #ededed80;
    }
  }
  .light-footer & {
    a,
    a:hover,
    a:active,
    a:visited {
      color: var(--mid);
    }
  }
  ${mediaMax('mobile')} {
    margin-left: 0;
    font-family: 'Basis Grotesque Pro';
    font-size: ${calculateMobileResponsiveSize(10)};
    font-weight: 400;
    line-height: ${calculateMobileResponsiveSize(16)};
    letter-spacing: ${calculateMobileResponsiveSize(2)};
    gap: ${calculateMobileResponsiveSize(16)};
    a,
    a:hover,
    a:active,
    a:visited {
      color: var(--light);
      white-space: nowrap;
    }
    .light-footer & {
      color: var(--blue);
      a {
        color: var(--blue);
      }
    }
  }
`
